
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const common_format = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
};

export const exportExcel = async (
    LEVEL_ID,
    YEAR,
    SEMESTER,
    PROJECT_NAME_TH,
    TYPE_DATA_TH,
    detail_mode,
    list_applicant,
    list_applicant_additional_data,
    passed_list_mode,
    selected_data,
    set_pass_mode,
    show_pass_mode,
    get_pass_order,
) => {
    const dateObject = new Date();
    const date_string = dateObject.toLocaleString("th-TH", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });

    const workbook = new ExcelJS.Workbook();
    // const workbook =  createAndFillWorkbook();
    workbook.creator = "Registrar KMITL";
    workbook.created = dateObject;

    const worksheet = workbook.addWorksheet("Report", {
        // pageSetup: { paperSize: 9, fitToPage: true, fitToHeight: 5, fitToWidth: 100 },
        pageSetup: { paperSize: 9, showGridLines: false },
    });
    // const cell = worksheet.getCell('A1');
    // cell.value = new Date(1968, 5, 1);

    // const row = worksheet.getRow(5);
    // row.addPageBreak();

    // worksheet.getCell('A6').value = 123;

    // worksheet.pageSetup.printTitlesRow = '1:3';

    worksheet.headerFooter.oddFooter = "หน้า &P จาก &N";

    // A4 : 8.3 * 11.7 inch = 83 117
    // width left = 83 - 1.4 = 81.6
    // height left = 117 - 1.5 - 0.6 = 114.9

    const l_border = 0.7;
    const r_border = 0.55;
    const t_border = 0.75;
    const b_border = 0.55;
    const hf_border = 0.3;
    //const lenght_new_page = 117 - 51 - 43 - 1.5; //All - numOfLine - random

    worksheet.pageSetup.margins = {
        left: l_border,
        right: r_border,
        top: t_border,
        bottom: b_border,
        header: hf_border,
        footer: hf_border,
    };

    // 82
    // worksheet.getCell("A1").value = 123;
    // worksheet.getCell("B1").value = 456;

    // worksheet.getCell("A2").value = 123;
    // worksheet.getCell("B2").value = 456;

    // const col1 = worksheet.getColumn(1);
    // col1.width = 70;

    // const col2 = worksheet.getColumn(2);
    // col2.width = 11.6;
    worksheet.getColumn(1).width = 8;
    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 15;
    worksheet.getColumn(5).width = 15;

    let row_num = 1;
    let column_num = 1;
    let new_page = true;
    const list = detail_mode
        ? list_applicant_additional_data
        : list_applicant;
    list.map((item, index) => {
        if (new_page) {
            worksheet.mergeCells("A" + String(row_num) + ":E" + String(row_num));
            worksheet.getCell("A" + String(row_num)).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            if (passed_list_mode) {
                worksheet.getCell("A" + String(row_num++)).value =
                    "แสดงรายชื่อผู้สมัครที่ผ่านการคัดเลือก ประจำปีการศึกษา " +
                    +SEMESTER +
                    "/" +
                    YEAR;
            } else {
                worksheet.getCell("A" + String(row_num++)).value =
                    "แสดงรายชื่อผู้สมัคร ประจำปีการศึกษา " +
                    SEMESTER +
                    "/" +
                    YEAR;
            }

            worksheet.mergeCells("A" + String(row_num) + ":E" + String(row_num));
            worksheet.getCell("A" + String(row_num)).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            worksheet.getCell("A" + String(row_num++)).value =
                "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง";

            worksheet.mergeCells("A" + String(row_num) + ":E" + String(row_num));
            worksheet.getCell("A" + String(row_num)).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            worksheet.getCell(
                "A" + String(row_num++)
            ).value = PROJECT_NAME_TH;

            worksheet.mergeCells("A" + String(row_num) + ":E" + String(row_num));
            worksheet.getCell("A" + String(row_num)).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            if (LEVEL_ID == "2" || LEVEL_ID == "3") {
                worksheet.getCell("A" + String(row_num++)).value =
                    "คณะ" +
                    item.FACULTY_NAME_TH +
                    " สาขา" +
                    item.CURRICULUM_NAME_TH +
                    " | ประเภทรับเข้า:" +
                    item.STUDY_ADMIT_TYPE_NAME_TH +
                    " | แผนการศึกษา:" +
                    item.STUDY_PLAN_NAME_TH +
                    " | ช่วงเวลาเรียน:" +
                    item.STUDY_CLASSES_NAME_TH +
                    " | เฉพาะ:" +
                    item.SPECIFIC_NATION_NAME_TH +
                    " (" +
                    TYPE_DATA_TH +
                    ")";
            } else {
                worksheet.getCell("A" + String(row_num++)).value =
                    "คณะ" +
                    item.FACULTY_NAME_TH +
                    " สาขา" +
                    item.CURRICULUM_NAME_TH +
                    " (" +
                    TYPE_DATA_TH +
                    ")";
            }
            // เริ่มวาดข้อมูลหัวตาราง-------------------------------------------------
            // -------------------------------------------------
            // ข้อมูลทั่วไปผู้สมัคร
            // -------------------------------------------------

            worksheet.getRow(row_num).getCell(column_num).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = "ลำดับที่";
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                "เลขที่ผู้สมัคร";
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).alignment = {
                vertical: "middle",
                horizontal: "center",
            };
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                "ชื่อ - นามสกุล";
            column_num++;
            // -------------------------------------------------
            if (
                (detail_mode && selected_data.nameSurname_eng) ||
                passed_list_mode
            ) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ชื่อ - นามสกุล (English)";
                column_num++;
            }
            // -------------------------------------------------
            if (set_pass_mode || show_pass_mode) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "สถานะ";
                column_num++;
            }
            // -------------------------------------------------
            if (!detail_mode || (detail_mode && selected_data.citizen_id)) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "รหัสบัตรประชาชน";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.birthday) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "วันเกิด";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.nation) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "สัญชาติ";
                column_num++;
            }
            // -------------------------------------------------
            if (!detail_mode || (detail_mode && selected_data.email)) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "Email";
                column_num++;
            }
            // -------------------------------------------------
            if (!detail_mode || (detail_mode && selected_data.mobile)) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "Mobile";
                column_num++;
            }
            // -------------------------------------------------
            if (!detail_mode || (detail_mode && selected_data.project)) {
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet.getRow(row_num).getCell(column_num).value = "โครงการ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.address) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "ที่อยู่";
                column_num++;
            }
            // -------------------------------------------------
            if (!detail_mode || (detail_mode && selected_data.notice)) {
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet.getRow(row_num).getCell(column_num).value = "หมายเหตุ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.order_1) {
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet.getRow(row_num).getCell(column_num).value = "สาขาที่เลือกอันดับ 1";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.order_2) {
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet.getRow(row_num).getCell(column_num).value = "สาขาที่เลือกอันดับ 2";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.order_3) {
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet.getRow(row_num).getCell(column_num).value = "สาขาที่เลือกอันดับ 3";
                column_num++;
            }
            // -------------------------------------------------
            // ข้อมูลโรงเรียน
            // -------------------------------------------------
            if (detail_mode && selected_data.school_name) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "โรงเรียน";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.school_type) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ประเภทโรงเรียน";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.education_type) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "แผนการศึกษา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.study_status) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "สถานภาพทางการศึกษา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.study_type) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ประเภทการศึกษา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.term_of_gpa) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "จำนวนเทอมของ GPA";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.gpa) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "GPA";
                column_num++;
            }
            // -------------------------------------------------
            // ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา
            // -------------------------------------------------
            // ข้อมูลการศึกษาตอนเรียน ป.ตรี
            if (detail_mode && selected_data.undergraduate_info) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "มหาวิทยาลัย (ป.ตรี)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ปีที่สำเร็จการศึกษา (ป.ตรี)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "สถานภาพการศึกษา (ป.ตรี)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "คุณวุฒิ/ปริญญา (ป.ตรี)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "สาขา (ป.ตรี)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "GPA (ป.ตรี)";
                column_num++;
            }
            // ข้อมูลการศึกษาตอนเรียน ป.โท
            if (detail_mode && selected_data.undergraduate_info) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "มหาวิทยาลัย (ป.โท)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ปีที่สำเร็จการศึกษา (ป.โท)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "สถานภาพการศึกษา (ป.โท)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "คุณวุฒิ/ปริญญา (ป.โท)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "สาขา (ป.โท)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "GPA (ป.โท)";
                column_num++;
            }
            // -------------------------------------------------
            // ข้อมูลสำหรับนานาชาติ
            // -------------------------------------------------
            if (detail_mode && selected_data.inter_info) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ประวัติการศึกษา";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #1 name)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #1 score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #1 วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #2 name)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #2 score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #2 วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #3 name)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #3 score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "AP/IB/IGCSE TEST SCORE (Subject #3 วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GED (Reasoning Through Language Arts)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GED (Mathematical Reasoning)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GED (Science)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GED (Social Studies)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GED (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT I (Mathematics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT I (readingWriting)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT I (Total)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT I (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "OLD SAT Subject test (Verbal)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "OLD SAT Subject test (Mathematics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "OLD SAT Subject test (Writing)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "OLD SAT Subject test (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Biology)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Chemistry)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Physics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Mathematics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "ACT (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ACT (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "IB (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "IB (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GAT 1 (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GAT 2 (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GAT (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "PAT 1 (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "PAT 3 (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "PAT (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "IELTS (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "IELTS (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "KMITL TEP (Score)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "KMITL TEP (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "Other name";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "Other score";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value = "วันที่สอบ";
                column_num++;
            }
            // -------------------------------------------------
            // ข้อมูลสำหรับแพทย์
            // -------------------------------------------------
            if (detail_mode && selected_data.med_info) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ประวัติการศึกษา";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Biology)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Chemistry)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Physics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (Mathematics)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "SAT II (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "BMAT (Section 1)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "BMAT (Section 2)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "BMAT (Section 3)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "BMAT (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "กสพท (คะแนน)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "กสพท (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (Internet based)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (Paper based)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (Computer based)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "TOEFL (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "IELTS (Academic Module)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "IELTS (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "CU-TEP (คะแนน)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "CU-TEP (วันที่สอบ)";
                column_num++;
                // -------------------------------------------------
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "Personal statement";
                column_num++;
            }
            // -------------------------------------------------
            // ข้อมูลประกอบหลักสูตรที่สมัคร
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_2) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA รวมทุกวิชา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_3) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาภาษาไทย";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_4) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาภาษาไทย";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_5) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาคณิตศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_6) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาคณิตศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_7) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาวิทยาศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_8) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาวิทยาศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_9) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาฟิสิกส์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_10) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาฟิสิกส์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_11) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาเคมี";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_12) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาเคมี";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_13) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาชีววิทยา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_14) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาชีววิทยา";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_15) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_16) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_17) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาภาษาอังกฤษ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_18) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาภาษาอังกฤษ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_20) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "GPA วิชาภาษาต่างประเทศ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_21) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "หน่วยกิต วิชาภาษาต่างประเทศ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_22) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ชื่อมาตรฐานความรู้ภาษาอังกฤษ";
                column_num++;
            }
            // -------------------------------------------------
            if (detail_mode && selected_data.constarint_23) {
                worksheet.getRow(row_num).getCell(column_num).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                worksheet
                    .getRow(row_num)
                    .getCell(column_num).border = common_format;
                worksheet.getRow(row_num).getCell(column_num).value =
                    "คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ";
                column_num++;
            }
            // -------------------------------------------------
            row_num++;
            column_num = 1;
            new_page = false;
        }
        // เริ่มวาดข้อมูล-------------------------------------------------
        // ข้อมูลทั่วไปผู้สมัคร
        worksheet.getRow(row_num).getCell(column_num).border = common_format;
        worksheet.getRow(row_num).getCell(column_num).value = index + 1;
        column_num++;
        // -------------------------------------------------
        worksheet.getRow(row_num).getCell(column_num).border = common_format;
        worksheet.getRow(row_num).getCell(column_num).value = item.REGISTER_ID;
        column_num++;
        // -------------------------------------------------
        let text_INITIALS_TH = "";
        if (item.INITIALS_TH) {
            text_INITIALS_TH = item.INITIALS_TH;
        }
        worksheet.getRow(row_num).getCell(column_num).border = common_format;
        worksheet.getRow(row_num).getCell(column_num).value =
            text_INITIALS_TH +
            " " +
            item.STUDENT_FNAME_TH +
            " " +
            item.STUDENT_LNAME_TH;
        column_num++;
        // -------------------------------------------------
        if (
            (detail_mode && selected_data.nameSurname_eng) ||
            passed_list_mode
        ) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.INITIALS_EN +
                " " +
                item.STUDENT_FNAME_EN +
                " " +
                item.STUDENT_LNAME_EN;
            column_num++;
        }
        // -------------------------------------------------
        if (set_pass_mode || show_pass_mode) {
            let text_show_status = "";
            if (show_pass_mode && !item.not_set && item.passed) {
                text_show_status = "ผ่าน";
            } else if (
                show_pass_mode &&
                !item.not_set &&
                !item.passed &&
                get_pass_order(item.regis_status) === "-"
            ) {
                text_show_status = "ไม่ผ่าน";
            } else if (
                show_pass_mode &&
                !item.passed &&
                get_pass_order(item.regis_status) !== "-"
            ) {
                text_show_status =
                    "(ติดสาขาที่เลือกลำดับที" +
                    get_pass_order(item.regis_status) +
                    ")";
            } else {
                text_show_status = "";
            }
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet
                .getRow(row_num)
                .getCell(column_num).value = text_show_status;
            column_num++;
        }
        // -------------------------------------------------
        if (!detail_mode || (detail_mode && selected_data.citizen_id)) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.CITIZEN_ID;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.birthday) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.BIRTHDAY;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.nation) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.NATION_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (!detail_mode || (detail_mode && selected_data.email)) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.EMAIL;
            column_num++;
        }
        // -------------------------------------------------
        if (!detail_mode || (detail_mode && selected_data.mobile)) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.MOBILE;
            column_num++;
        }
        // -------------------------------------------------
        if (!detail_mode || (detail_mode && selected_data.project)) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.PROJECT_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.address) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.ADDRESS;
            column_num++;
        }
        // -------------------------------------------------
        if (!detail_mode || (detail_mode && selected_data.notice)) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            if (passed_list_mode) {
                worksheet.getRow(row_num).getCell(column_num).value =
                    "ติดสาขาที่เลือกลำดับที่ " + item.ORDER;
            } else {
                worksheet.getRow(row_num).getCell(column_num).value = "";
            }
            column_num++;
        }
        if (detail_mode && selected_data.order_1) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.ORDER_1_CURRICULUM_NAME_TH;
            column_num++;
        }
        if (detail_mode && selected_data.order_2) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.ORDER_2_CURRICULUM_NAME_TH;
            column_num++;
        }
        if (detail_mode && selected_data.order_3) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value = item.ORDER_3_CURRICULUM_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        // ข้อมูลโรงเรียน
        // -------------------------------------------------
        if (detail_mode && selected_data.school_name) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.SCHOOL_NAME;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.school_type) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.SCHOOL_TYPE_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.education_type) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.EDUCATION_TYPE_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.study_status) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.SCHOOL_STUDY_STATUS_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.study_type) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.SCHOOL_STUDY_TYPE_NAME_TH;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.term_of_gpa) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_ungrad_TERM_OF_GPA;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.gpa) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_ungrad_GPA;
            column_num++;
        }
        // -------------------------------------------------
        // ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา
        // -------------------------------------------------
        // ข้อมูลการศึกษาตอนเรียน ป.ตรี
        if (detail_mode && selected_data.undergraduate_info) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_COUNTRY_ID_OF_UNIVERSITY === "TH"
                    ? item.UNIVERSITY_NAME_TH
                    : item.edubg_grad_UNIVERSITY_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_GRADUATED_YEAR;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.UNIVERSITY_STUDY_STATUS_NAME_TH;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_DEGREE_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_CURRICULUM_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_GPA;
            column_num++;
        }
        // ข้อมูลการศึกษาตอนเรียน ป.โท
        if (detail_mode && selected_data.master_info) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_COUNTRY_ID_OF_UNIVERSITY === "TH"
                    ? item.MASTER_UNIVERSITY_NAME_TH
                    : item.edubg_grad_MASTER_UNIVERSITY_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_MASTER_GRADUATED_YEAR;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.MASTER_UNIVERSITY_STUDY_STATUS_NAME_TH;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_MASTER_DEGREE_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_MASTER_CURRICULUM_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_grad_MASTER_GPA;
            column_num++;
        }
        // -------------------------------------------------
        // ข้อมูลสำหรับนานาชาติ
        // -------------------------------------------------
        if (detail_mode && selected_data.inter_info) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_DIPLOMA_TYPE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_1_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_1_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_1_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_2_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_2_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_2_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_3_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_3_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SUBJECT_3_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GED_RTLA_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GED_MR_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GED_SCI_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GED_SS_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GED_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_1_MATH_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_1_RW_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_1_TOTAL_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_1_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OLD_SAT_VERBAL_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OLD_SAT_MATH_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OLD_SAT_WRITING_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OLD_SAT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_2_BIO_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_2_CHEM_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_2_PHY_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_2_MATH_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_SAT_2_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_ACT_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_ACT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_IB_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_IB_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GAT_1_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GAT_2_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_GAT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_PAT_1_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_PAT_3_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_PAT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_TOFEL_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_TOFEL_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_IELTS_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_IELTS_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_KMITL_TEP_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_KMITL_TEP_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OTHER_NAME;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OTHER_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_inter_OTHER_TEST_DATE;
            column_num++;
        }
        // -------------------------------------------------
        // ข้อมูลสำหรับแพทย์
        // -------------------------------------------------
        if (detail_mode && selected_data.med_info) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_DIPLOMA_TYPE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SAT_2_BIO_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SAT_2_CHEM_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SAT_2_PHY_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SAT_2_MATH_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SAT_2_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_BMAT_SECTION_1_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_BMAT_SECTION_2_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_BMAT_SECTION_3_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_BMAT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SPOT_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_SPOT_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_TOEFL_IBT_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_TOEFL_PBT_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_TOEFL_CBT_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_TOFEL_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_IELTS_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_IELTS_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_CU_TEP_SCORE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_CU_TEP_TEST_DATE;
            column_num++;
            // -------------------------------------------------
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.edubg_medicine_PERSONAL_STATEMENT;
            column_num++;
        }
        // -------------------------------------------------
        // ข้อมูลประกอบหลักสูตรที่สมัคร
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_2) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_2;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_3) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_3;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_4) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_4;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_5) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_5;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_6) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_6;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_7) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_7;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_8) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_8;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_9) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_9;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_10) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_10;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_11) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_11;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_12) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_12;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_13) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_13;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_14) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_14;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_15) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_15;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_16) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_16;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_17) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_17;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_18) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_18;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_20) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_20;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_21) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_21;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_22) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_22;
            column_num++;
        }
        // -------------------------------------------------
        if (detail_mode && selected_data.constarint_23) {
            worksheet.getRow(row_num).getCell(column_num).border = common_format;
            worksheet.getRow(row_num).getCell(column_num).value =
                item.user_constraint_CONSTRAINT_ID_23;
            column_num++;
        }
        // -------------------------------------------------
        row_num++;

        // if ((index + 1) % lenght_new_page === 0) {
        //     worksheet.mergeCells("A" + String(row_num) + ":J" + String(row_num));
        //     worksheet.getCell("A" + String(row_num)).alignment = {
        //         vertical: "middle",
        //         horizontal: "right",
        //     };
        //     // worksheet.getCell("A" + String(row_num++)).value =
        //     //     "ข้อมูลวันทื่ " + date_string + " ";
        //     new_page = true;
        //     const row = worksheet.getRow(row_num++);
        //     row.addPageBreak();
        // }
        column_num = 1;
    });

    row_num++;
    worksheet.mergeCells("A" + String(row_num) + ":E" + String(row_num));
    worksheet.getCell("A" + String(row_num)).alignment = {
        vertical: "middle",
        horizontal: "left",
    };
    worksheet.getCell("A" + String(row_num)).value =
        "ข้อมูลวันที่ " + date_string + "น.";

    //-----------------------------------------------

    const buffer = await workbook.xlsx.writeBuffer();
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    saveAs(blob, "report" + fileExtension);
}